import router from "./router";
import jwtDecode from "jwt-decode";
import store from "@/common/store";
// import cfg from '../../public/static/cfg'
import api from "./api";
import socket from "./socket";
import { getLodop } from "@/common/LodopFuncs";
//获取当月的天数
function getDaysOfMonth(dateStr) {
  var date = new Date(dateStr);
  var year = date.getFullYear();
  var mouth = date.getMonth() + 1;
  var day = 0;

  if (mouth == 2) {
    day = isLeapYear(year) ? 29 : 28;
  } else if (mouth == 1 || mouth == 3 || mouth == 5 || mouth == 7 || mouth == 8 || mouth == 10 || mouth == 12) {
    day = 31;
  } else {
    day = 30;
  }
  return day;
}

//判断是否为闰年
function isLeapYear(year) {
  return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
}
const utils = {
  serverTime: new Date(),
  sys: cfg.sys,
  install(Vue) {
    Vue.prototype.$utils = this;
    Vue.filter("fmtFloat", (value, count = 4) => {
      return utils.fmtFloat(value, count);
    });
    Vue.filter("fmtDate", (value) => {
      return utils.fmtDate(value);
    });
    Vue.filter("fmtTime", (value) => {
      return utils.fmtTime(value);
    });
    Vue.filter("fmtDateTime", (value) => {
      return utils.fmtDateTime(value);
    });
    Vue.filter("age", (value) => {
      return utils.age(value);
    });
    Vue.filter("dictText", function (code, type) {
      return utils.dictText(code, type);
    });
    Vue.filter("mask", (value) => {
      return utils.mask(value);
    });
    // this.init()
  },
  async init() {
    this.serverTime = await this.getServerTime();
  },
  fmtFloat: function (value, count = 4) {
    if (isNaN(value)) {
      return 0;
    } else {
      return Number(value + 0.000001).toFixed(count);
    }
  },
  fmtDate(value) {
    if (!value) {
      return value;
    }
    try {
      const dt = new Date(value);
      if (dt instanceof Date && !isNaN(dt.getTime())) {
        return `${dt.getFullYear()}-${dt.getMonth() < 9 ? "0" : ""}${dt.getMonth() + 1}-${dt.getDate() < 10 ? "0" : ""}${dt.getDate()}`;
      }
    } catch (error) {
      console.log(error);
      return value;
    }
  },
  fmtTime(value) {
    if (!value) {
      return value;
    }
    try {
      const dt = new Date(value);
      if (dt instanceof Date && !isNaN(dt.getTime())) {
        return `${dt.getHours() < 10 ? "0" : ""}${dt.getHours()}:${dt.getMinutes() < 10 ? "0" : ""}${dt.getMinutes()}:${dt.getSeconds() < 10 ? "0" : ""}${dt.getSeconds()}`;
      }
    } catch (error) {
      console.log(error);
      return value;
    }
  },
  fmtDateTime(value) {
    if (!value) {
      return value;
    }
    try {
      const dt = new Date(value);
      if (dt instanceof Date && !isNaN(dt.getTime())) {
        return `${this.fmtDate(value)} ${dt.getHours() < 10 ? "0" : ""}${dt.getHours()}:${dt.getMinutes() < 10 ? "0" : ""}${dt.getMinutes()}:${dt.getSeconds() < 10 ? "0" : ""}${dt.getSeconds()}`;
      }
    } catch (error) {
      console.log(error);
      return value;
    }
  },
  weekday(value) {
    try {
      return "星期" + "日一二三四五六".charAt(new Date(value).getDay());
    } catch (err) {
      return value;
    }
  },
  monday(value) {
    let curDate = new Date(value);
    var day = curDate.getDay() === 0 ? 7 : curDate.getDay();
    return new Date(curDate.setDate(curDate.getDate() - (day - 1)));
  },
  //排序函数rev是否升序是否排序
  compare(property, rev) {
    try {
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
      }
      return (pre, next) => {
        return pre[property] > next[property] && pre[property] !== next[property] ? rev * 1 : rev * -1;
      };
    } catch (err) {
      return property;
    }
  },
  async getServerTime() {
    let date = await api.getServerTime();
    return date;
    // var now = new Date();
    // var year = now.getFullYear(); //得到年份
    // var month = now.getMonth(); //得到月份
    // var date = now.getDate(); //得到日期
    // month = month + 1;
    // month = month.toString().padStart(2, "0");
    // date = date.toString().padStart(2, "0");
    // var defaultDate = `${year}-${month}-${date}`;
    // return defaultDate;
  },
  age(birthday) {
    try {
      let myDate = new Date(birthday);
      let myYear = myDate.getFullYear();
      let myMonth = myDate.getMonth() + 1;
      let myDay = myDate.getDate();
      let myHour = myDate.getHours();
      let myMinute = myDate.getMinutes();
      let mySecond = myDate.getSeconds();

      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      let day = now.getDate();
      let hour = now.getHours();
      let minute = now.getMinutes();
      let second = now.getSeconds();

      let gapSecond = second - mySecond;
      if (gapSecond < 0) {
        minute -= 1;
        gapSecond = 60 - mySecond + second;
      }
      let gapMinute = minute - myMinute;
      if (gapMinute < 0) {
        hour -= 1;
        gapMinute = 60 - myMinute + minute;
      }
      let gapHour = hour - myHour;
      if (gapHour < 0) {
        day -= 1;
        gapHour = 24 - myHour + hour;
      }
      let gapDay = day - myDay;
      if (gapDay < 0) {
        month -= 1;
        gapDay = getDaysOfMonth(birthday) - myDay + day;
      }
      let gapMonth = month - myMonth;
      if (gapMonth < 0) {
        year -= 1;
        gapMonth = 12 - myMonth + month;
      }
      let gapYear = year - myYear;
      if (gapYear < 0) {
        gapYear = 0;
      }

      let dateStr = "0 岁";

      if (gapYear > 0) {
        return `${gapYear} 岁`;
      }
      if (gapMonth > 0) {
        return `${gapMonth} 月`;
      }
      if (gapDay > 0) {
        return `${gapDay} 天`;
      }
      if (gapHour > 0) {
        return `${gapHour} 小时`;
      }
      if (gapMinute > 0) {
        return `${gapHour} 分钟`;
      }
      if (gapSecond > 0) {
        return `${gapSecond} 秒`;
      }

      return dateStr;
    } catch (error) {
      return "格式错误";
    }
  },
  // age(strAge) {
  //   let err = "日期格式错误";
  //   if (!strAge) {
  //     return err;
  //   }
  //   let birArr = strAge.split("-");
  //   if (!birArr) {
  //     return err;
  //   }
  //   let birYear = birArr[0];
  //   let birMonth = birArr[1];
  //   let birDay = birArr[2];
  //   let d = new Date(birYear, birMonth - 1, birDay);
  //   if (d.getFullYear() != birYear || d.getMonth() + 1 != birMonth || d.getDate() != birDay) {
  //     return err;
  //   }

  //   d = new Date();
  //   let nowYear = d.getFullYear();
  //   let nowMonth = d.getMonth() + 1; //记得加1
  //   let nowDay = d.getDate();

  //   let returnAge;
  //   let unit = "岁"

  //   if (nowYear == birYear) {
  //     returnAge = 0; //
  //   } else {
  //     let ageDiff = nowYear - birYear; //
  //     if (ageDiff > 0) {
  //       if (nowMonth == birMonth) {
  //         let dayDiff = nowDay - birDay; //
  //         if (dayDiff < 0) {
  //           returnAge = ageDiff - 1;
  //         } else {
  //           returnAge = ageDiff;
  //         }
  //       } else {
  //         let monthDiff = nowMonth - birMonth; //
  //         if (monthDiff < 0) {
  //           returnAge = ageDiff - 1;
  //         } else {
  //           returnAge = ageDiff;
  //         }
  //       }
  //     } else {
  //       return -1; // "出生日期晚于今天，数据有误"; //返回-1 表示出生日期输入错误 晚于今天
  //     }
  //   }
  //   return `${returnAge} ${unit}`;
  // },
  spanTime(startTime, endTime, returnPart) {
    try {
      let start = new Date(startTime).getTime();
      let end = new Date(endTime).getTime();
      let span = end - start;

      let hours = Math.floor(span / (3600 * 1000));
      //计算相差分钟数
      let leave2 = span % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      let seconds = Math.round(leave3 / 1000);

      if (seconds == 60) {
        seconds = 0;
        minutes++;
      }
      if (minutes == 60) {
        minutes = 0;
        hours++;
      }
      if (returnPart == "h") {
        return hours;
      }
      if (returnPart == "m") {
        return hours * 60 + minutes;
      }
      if (returnPart == "s") {
        return hours * 60 * 60 + minutes * 60 + seconds;
      }
      return `${hours < 10 ? "0" : ""}${hours}:${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    } catch (error) {
      return "";
    }
  },
  chaineseMoney(n) {
    var fraction = ["角", "分"];
    var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
    var unit = [
      ["元", "万", "亿"],
      ["", "拾", "佰", "仟"],
    ];
    var head = n < 0 ? "欠" : "";
    n = Math.abs(n);
    var s = "";
    for (var i = 0; i < fraction.length; i++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, "");
    }
    s = s || "整";
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
      var p = "";
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
    }
    return (
      head +
      s
        .replace(/(零.)*零元/, "元")
        .replace(/(零.)+/g, "零")
        .replace(/^整$/, "零元整")
    );
  },
  dictText: function (code, type) {
    const myDicts = store.getters.getDict(type);
    const myMedDicts = store.getters.getMedDict(type)
    if ((code || code === 0) && myDicts && myDicts.length) {
      let dict = myDicts.find((d) => d.code.toString() === code.toString());
      if (dict) {
        return dict.text || dict.name;
      }
      return code;
    } else if (code && myMedDicts && myMedDicts.length) {
      const item = myMedDicts.find(t => t.code === code)
      return item?.name || code
    } else {
      return code;
    }
  },
  onInputMoney: function (value) {
    value = value.replace(/[^0-9.]/g, "");
    value = value.replace(/(.*\..*)\..*/g, "$1");
    return value;
  },
  mask(id) {
    if (!id) {
      return "";
    }
    let code = String(id);
    if (code.length > 2) {
      let len = code.length / 6;
      return code.substring(0, len) + "……" + code.substring(code.length - len, code.length);
    } else {
      return code.substring(0, 0) + "……";
    }
  },
  calogin() {
    const uri = `${cfg.oauth.server}/oauth/authorize?response_type=code&client_id=${cfg.oauth.client}&redirect_uri=${encodeURI(cfg.oauth.callbackUrl)}`;
    location.replace(uri);
  },
  loadChildren(ps, p) {
    let re = new RegExp("^" + p.code + "*$")
    let children = ps.filter(d => {
      if (re.test(d.parentCode)) {
        d.hasParent = true;
        return true;
      } else {
        return false;
      }
    });
    if (children && children.length) {
      p.children = children;
    }
  },
  generateTreeData(items) {
    if (!items || !items.length) {
      return [];
    }
    items.forEach(item => {
      item.label = item.name;
      this.loadChildren(items, item);
    });
    return items.filter(item => {
      return !item.hasParent;
    });
  },
  // 根据源对象的属性从源对象拷贝属性值
  propertyCopy(src, target, scope, properties = [], excludeKeys) {
    if (!properties || !properties.length) {
      properties = Object.keys(src).map((k) => ({ src: k, tgt: k }));
    }
    if (excludeKeys) {
      let exKeys = excludeKeys.split(",");
      properties = properties.filter((p) => !exKeys.includes(p.src));
    }

    properties.forEach((prop) => {
      if (scope) {
        scope.$set(target, prop.tgt, src[prop.src]);
      } else {
        target[prop.tgt] = src[prop.src];
      }
    });
  },
  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  log(msg) {
    if (cfg.isDev) {
      console.log(msg);
    }
  },
  idCard(id) {
    if (id == null || id == undefined) {
      return {};
    }
    let idNo = String(id);
    let birthday = `${idNo.substring(6, 10)}-${idNo.substring(10, 12)}-${idNo.substring(12, 14)}`;
    let gender = `${parseInt(idNo.substr(16, 1)) % 2 == 1 ? "1" : "2"}`;
    return { birthday, gender, idNo };
  },
  saveToken(res) {
    store.commit("token", res.access_token);
    store.commit("refToken", res.refresh_token);
    const tokenObj = jwtDecode(res.access_token);
    store.state.tokenExp = tokenObj.exp + "000";
    store.state.lastRefreshTime = new Date().getTime();
  },
  logout() {
    if (this.logining) {
      return;
    }
    store.commit("clear");
    socket.disconnect();
    location.replace(cfg.oauth.server);
  },
  goErr(err) {
    router.replace({ name: "err", params: { err: err } });
  },
  cardRule(idType) {
    let rule = [{ required: true, message: "证件号码不允许空！" }];
    switch (idType) {
      case "SF": // 身份证
        rule.push({
          pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
          message: "身份证号格式不正确！",
        });
        break;
      case "HK": // 户口本
        // 规则： 15位数字, 18位数字, 17位数字 + X
        // 样本： 441421999707223115
        rule.push({
          pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          message: "户口本号码格式不正确！",
        });
        break;
      case "HZ": // 护照
        // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
        // 样本： 141234567, G12345678, P1234567
        rule.push({
          pattern: /^([a-zA-z]|[0-9]){5,17}$/,
          message: "护照号格式不正确！",
        });
        break;
      case "JG": // 军官证
        // 规则： 军/兵/士/文/职/广/（其他中文） + "字第" + 4到8位字母或数字 + "号"
        // 样本： 军字第2001988号, 士字第P011816X号
        rule.push({
          pattern: /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/,
          message: "军官证号格式不正确！",
        });
        break;
      case "GA": // 港澳
        // 规则： H/M + 10位或6位数字
        // 样本： H1234567890
        rule.push({
          pattern: /^([A-Z]\d{6,10}(\(\w{1}\))?)$/,
          message: "港澳居民来往内地通行证号码格式不正确！",
        });
        break;
      case "TW": // 台湾
        // 规则： 新版8位或18位数字， 旧版10位数字 + 英文字母
        // 样本： 12345678 或 1234567890B
        rule.push({
          pattern: /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/,
          message: "台湾居民来往大陆通行证号码格式不正确！",
        });
        break;
      default:
        break;
    }

    return rule;
  },
  printRpt(code, data) {
    return new Promise((resolve, reject) => {
      api
        .getPrintTemplate({ code: code })
        .then((res) => {
          if (res.items && res.items.length > 0) {
            let LODOP = getLodop();
            // 设置模板
            eval(res.items[0].content);
            // 设置数据
            let struct = JSON.parse(res.items[0].struct);
            if (data) {
              Object.entries(data).forEach(([item, value]) => {
                if (Array.isArray(value)) {
                  const config = struct[item];
                  this.setArrayData(LODOP, config, value);
                } else if (typeof value === "string") {
                  LODOP.SET_PRINT_STYLEA(item, "CONTENT", value);
                }
              });
            }
            // 使用配置打印机
            const printerConfig = localStorage.getItem('printerConfig') ? JSON.parse(localStorage.getItem('printerConfig')) : null;
            if (printerConfig && printerConfig.registeredPrintVoucher && code === 'RegReceipt') {
              // 设置网络共享打印机不畅通时是否阻止弹窗提示。
              LODOP.SET_PRINT_MODE('TRYLINKPRINTER_NOALERT', true);
              LODOP.SET_PRINTER_INDEX(printerConfig.registeredPrintVoucher);
              LODOP.PRINT();
            } else if(printerConfig && printerConfig.invoicePrint && code === 'OpInvoice') {
              LODOP.SET_PRINTER_INDEX(printerConfig.invoicePrint);
              LODOP.PRINT();
            } else {
               // LODOP.PREVIEW();
              LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS", true);
              LODOP.On_Return = function (TaskID, Value) {
                LODOP.On_Return = function (TaskID1, Value1) {
                  if (Value1 == 0) {
                    resolve("打印成功！");
                  } else if (Value1 == 1) {
                    reject("打印失败");
                  }
                };
                // LODOP.GET_VALUE('PRINT_STATUS_OK', Value);
                LODOP.GET_VALUE("PRINT_STATUS_EXIST", Value);
              };
              LODOP.PRINTA();
            }
          } else {
            console.error("error: 没有找到模板.");
            reject("未找到发票模板信息，请联系管理员。");
          }
        })
        .catch((err) => {
          console.error("error: 模板获取失败.");
          reject("打印模板获取失败。");
        });
    });
  },
  setArrayData(lodop, config, data) {
    const [rCnt, cCnt, mode] = [config.row.count, config.col.count, config.mode];
    let [row, col] = [-1, -1];
    const rdCnt = rCnt * cCnt;
    for (let i = 0; i < data.length; i++) {
      if (i == rdCnt) break;
      if (mode === "row") {
        col = i % cCnt;
        row += !col ? 1 : 0;
      } else if (mode === "col") {
        row = i % rCnt;
        col += !row ? 1 : 0;
      }
      const top = config.row.start + config.row.step * row;
      const left = config.col.start + config.col.step * col;
      if (i == rdCnt - 1) {
        if (data.length > rdCnt) {
          lodop.ADD_PRINT_TEXTA("end", top, left, 30, 20, "<参见附页>");
          continue;
        }
      }
      Object.entries(config.cols).forEach(([item, value]) => {
        lodop.ADD_PRINT_TEXTA(item, top + value.position[0], left + value.position[1], value.position[2], value.position[3], data[i][item]);
        Object.entries(value.style).forEach(([n, v]) => {
          lodop.SET_PRINT_STYLEA(0, n, v);
        });
      });
    }
  },
  padLeft (str, len, val) {
    if (str && str.length < len) {
      return Array(len - str.length + 1).join(val) + str;
    }
    return str;
  },
  selectRuleFn(val = ''){
    return [{ required: true, message: `请选择${val}`, trigger: 'change' }];
  },
  inputRuleFn(val = ''){
    return [{ required: true, message: `请输入${val}`, trigger: 'blur' }];
  },
};
export default utils;
